import { v4 as uuid } from 'uuid';

import { UserBrowser } from '@soluto-private/mx-user-browser';

import { fetchHttpClient } from '@service-initiation/shared-clients-fetch-http';
import {
  type HttpClient,
  type HttpClientRequestOptions,
  type HttpClientResponse,
} from '@service-initiation/shared-clients-http';

const getSharedHeaders = () => {
  const requestId = uuid();

  return {
    'X-Request-Id': requestId,
    'X-UserBrowser-Session-Id': UserBrowser.SessionId,
    ...(UserBrowser.Id && { 'X-UserBrowser-Id': UserBrowser.Id }),
  };
};

export const httpClient: HttpClient = {
  delete: async (url: string, options?: HttpClientRequestOptions) =>
    await fetchHttpClient.get(url, {
      ...options,
      headers: {
        ...getSharedHeaders(),
        ...options?.headers,
      },
    }),
  get: async (url: string, options?: HttpClientRequestOptions) =>
    await fetchHttpClient.get(url, {
      ...options,
      headers: {
        ...getSharedHeaders(),
        ...options?.headers,
      },
    }),
  patch: async <Request, Response>(
    url: string,
    body: Request,
    options?: HttpClientRequestOptions
  ): Promise<HttpClientResponse<Response>> =>
    await fetchHttpClient.patch(url, body, {
      ...options,
      headers: {
        ...getSharedHeaders(),
        ...options?.headers,
      },
    }),
  post: async <Request, Response>(
    url: string,
    body: Request,
    options?: HttpClientRequestOptions
  ): Promise<HttpClientResponse<Response>> =>
    await fetchHttpClient.post(url, body, {
      ...options,
      headers: {
        ...getSharedHeaders(),
        ...options?.headers,
      },
    }),
  put: async <Request, Response>(
    url: string,
    body: Request,
    options?: HttpClientRequestOptions
  ): Promise<HttpClientResponse<Response>> =>
    await fetchHttpClient.post(url, body, {
      ...options,
      headers: {
        ...getSharedHeaders(),
        ...options?.headers,
      },
    }),
};
